import type { CSSProperties } from 'react';

export type SkeletonProps = {
  variant?: 'text' | 'circle' | 'rect';
  width?: number | string;
  height?: number | string;
  className?: string;
};

export function Skeleton({ variant = 'rect', width, height, className }: SkeletonProps) {
  const style: CSSProperties = { width, height };

  return (
    <span
      className={['hopper-skeleton', `hopper-skeleton--${variant}`, className].filter(Boolean).join(' ')}
      style={style}
      aria-hidden="true"
    />
  );
}
